import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { notification } from "antd";

export const messageSlice = createSlice({
  name: "message",
  initialState: {
    messageList: [],
  },
  reducers: {
    setMessageList: (state, action) => {
      state.messageList = action.payload;
    },

    deleteMessage: (state, action) => {
      state.messageList = state.messageList.filter(
        (x) => x.id !== action.payload
      );
    },

    toggleReadMessage: (state, action) => {
      let message = state.messageList.find((x) => x.id === action.payload);
      message.isRead = !message.isRead;
    },
  },
});

export const { setMessageList, deleteMessage, toggleReadMessage } =
  messageSlice.actions;

export const selectMessages = (state) => state.message.messageList;

export default messageSlice.reducer;

export const getMessagesList =
  (startDate, endDate, searchKeyword, pageNumber, pageSize, callback) =>
  (dispatch) => {
    axios
      .get("message/getList", {
        params: {
          startDate,
          endDate,
          searchKeyword,
          pageNumber,
          pageSize,
        },
      })
      .then(({ data }) => {
        dispatch(setMessageList(data.messages));
        callback && callback(data.totalCount);
      })
      .catch((error) => {
        notification.error({ message: error.response.data.message });
        callback && callback();
      });
  };

export const deleteMessageById = (id, callback) => (dispatch) => {
  axios
    .delete(`message/${id}`)
    .then(({ data }) => {
      notification.success({ message: "Successfully deleted message" });
      dispatch(deleteMessage(id));
      callback && callback();
    })
    .catch((error) => {
      notification.error({ message: error.response.data.message });
      callback && callback();
    });
};

export const toggleReadMessageById = (id, callback) => (dispatch) => {
  axios
    .patch(`message/toggleRead/${id}`)
    .then(({ data }) => {
      // notification.success({ message: "Successfully updated message status" });
      dispatch(toggleReadMessage(id));
      callback && callback();
    })
    .catch((error) => {
      notification.error({ message: error.response.data.message });
      callback && callback();
    });
};
